import { HapticsProvider, useHaptics } from './HapticsProvider';

export { HapticsProvider, useHaptics };
